import React from 'react'
import clsx from 'clsx'
import { IconButton } from '@material-ui/core'

import { Dai } from 'components'

import mixpanel from 'helpers/mixpanel'

import useCustomTheme from 'hooks/useCustomTheme'
import useDaiChat from 'hooks/useDaiChat'

import useStyles from './styles'
import constants from 'constants/index'

const DaiStarIconButton = () => {
  const classes = useStyles()
  const { customThemeIsActive } = useCustomTheme()
  const { chatOpen, handleOpenChatPanel, handleCloseChat } = useDaiChat()

  const { TAGS } = constants.dai.solutions

  const registerMixpanelEvent = (action) => {
    mixpanel.track('DAI', 'Chat Plataforma', {
      action: `dai-chat-plataforma-${action}`,
      page: window.location.pathname,
      pageTitle: document.title,
    })
  }

  const handleChangeChatState = () => {
    if (!chatOpen) {
      registerMixpanelEvent('open')
      handleOpenChatPanel()
    } else {
      handleCloseChat()
    }
  }

  return (
    <Dai.Permitted tag={TAGS.DAI_CHAT_PLATFORM}>
      <IconButton
        size="medium"
        className={clsx({
          [classes.customIconButton]: customThemeIsActive,
          [classes.standardIconButton]: !customThemeIsActive,
          [classes.standardIconButtonActive]: chatOpen && !customThemeIsActive,
          [classes.customIconButtonActive]: chatOpen && customThemeIsActive,
        })}
        onClick={handleChangeChatState}
      >
        <Dai.StarIcon size="24px" color="currentColor" />
      </IconButton>
    </Dai.Permitted>
  )
}

export default DaiStarIconButton
